
/**
 * http://build.fhir.org/questionnaireresponse.html
 * 
 * A structured set of questions and their answers. The questions are 
 * ordered and grouped into coherent subsets, corresponding to the 
 * structure of the grouping of the questionnaire being responded to. 
 * 
 * QuestionnaireResponse provides a complete or partial list of answers 
 * to a set of questions filled when responding to a questionnaire. 
 * The questions may be included directly or by reference 
 * to a Questionnaire resource that defines the questions as well 
 * as the constraints on the allowed answers. 
 * 
 * 
 */ 

function QuestionnaireResponse(){
    this.resourceType = 'QuestionnaireResponse';
    this.status = "in-progress";
    this.item        = [];
}


/**
 * -
 * 
 * @param Patient subject
 */
 QuestionnaireResponse.prototype.setSubject = function( subject ) {
  this.subject = subject;
};


/**
 * Set original Questionnaire form being answered
 * 
 * @param object original
 */
 QuestionnaireResponse.prototype.setSourceQuestionnaireResource = function( original ) {
  //this.questionnaire = original;
  this.questionnaire = original.reference;
};


export default QuestionnaireResponse;
